/**
 * Gọi AI dựng luồng (backend thật: /api/v1/automation-v2/ai/flow).
 * Backend nạp sẵn lớp nền lược đồ workflow rồi trả luồng JSON đã kiểm tra.
 */
import { useMutation } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import type { FlowEdgeV2, FlowNodeV2 } from '@/lib/automation-v2/types'

export interface LuotChatLuong { role: 'user' | 'assistant'; text: string }

export interface YeuCauAiLuong {
  message: string
  luongHienTai?: { name?: string; nodes: FlowNodeV2[]; edges: FlowEdgeV2[] } | null
  nguon?: Array<{ id: string; type: string; name: string }>
  anhXa?: Array<{ id: string; source: string; name: string }>
  provider?: string | null
  model?: string | null
  lichSu?: LuotChatLuong[]
}

export interface KetQuaAiLuong {
  traLoi: string
  luong: { name?: string; nodes: FlowNodeV2[]; edges: FlowEdgeV2[] } | null
  thayDoi: string[]
  provider: string
  model: string
  canhBao?: string
}

export function useAiDungLuong() {
  return useMutation({
    mutationFn: async (body: YeuCauAiLuong): Promise<KetQuaAiLuong> => {
      const { data } = await api.post<KetQuaAiLuong>('/automation-v2/ai/flow', body)
      return data
    },
  })
}
